import { Typography } from "@material-ui/core";

const titleOfManuscript = "This is the title of your manuscript.";
const coverLetter = "Provide a short comprehensive title of no more than 50 characters eg.";
const articleTitle =
  "The title (font 14) should be specific to the study yet concise, and should allow sensitive and specific electronic retrieval of the article. It should be comprehensible to readers outside your field. Avoid specialist abbreviations if possible. Present this in Sentence case, capitalizing only the first word or names, and abbreviations, e.g.:";
const firstTime =
  "Please indicate if the manucsript has already been submitted to Rhinology journal as original contribution";
const previousId =
  "Please indicate id of the manucsript previously submmitted to Rhinology journal as original contribution";
const correction = "Place comments to the editor in chief regarding your article here. ";

const abstract = (
  <table>
    <tr>This is a summary of your article.</tr>
    <tr> Your summary should contain:</tr>
    <tr>
      <ul>
        <li>
          - <b>Introduction</b> to the subject
        </li>
        <li>
          - The <b>methods</b> of research used
        </li>
        <li>
          - The <b>results</b> of the research
        </li>
        <li>
          - The <b>conclusion</b>
        </li>
      </ul>
    </tr>
  </table>
);
const keywords = (
  <table>
    <tr>Provide up to 5 key words.</tr>
    <tr>To assign keywords to your article, select one or several keywords from the left box and press add.</tr>
    <tr></tr>
    <tr></tr>
    <tr>
      If you have selected a keyword by mistake, you can remove it by selecting it in the right box and pressing remove.
    </tr>
  </table>
);

const type = (types: any) => {
  return (
    <table>
      {types.map((obj: any) => {
        return (
          <tr id={obj.id}>
            <td style={{ width: "150px" }}>{obj.name}</td>
            <td>{obj.description}</td>
          </tr>
        );
      })}
    </table>
  );
};

const manuscriptFigures = (
  <div>
    <Typography>
      Download the template file and use it to compose your article. <br />
      Please follow the instructions in the template
      <br /> Manuscripts not following the template will be rejected instantly!
    </Typography>
    <Typography>
      The maximum file size for your manuscript is 5MB. This should not include your figures, which will be uploaded as
      separate files.
      <br /> You can only upload the following file types:
      <br /> - .doc (word 2003;
      <br /> - mac word 2004)
      <br /> - .docx (word 2007,2010;
      <br /> - mac word 2008,2011) <br />
      - .odt (open office writer) Your figures can be uploaded here as well and should be uploaded as: <br />- .png
      <br /> - .jpg
      <br /> Your video can be uploaded here as well and should be uploaded as:
      <br /> - .avi
      <br /> - .ogv
      <br /> - .mp4
      <br /> - .flv
      <br /> - .webm
      <br /> - .3gp
    </Typography>
  </div>
);

const usersTitle = (
  <div>
    <p>A clear distinction must be made between users and authors.</p>
    <p>Users are people who have registered on the website and have the option to upload articles.</p>
    <p>When uploading articles they have the ability to add authors to an article.</p>
    <p>These authors do not get an account on the website.</p>
    <p>This list shows the users of rhinology and allows you to login on their account</p>.<br />
  </div>
);

const reviewComments = (
  <div>
    <b>Comments to the author(s)</b>
    <p>(These are the comments that the author will receive.</p>
    <p>
      In the space below, please pase a Word-processing file of your review. Please elaborate on your summary
      evaluations above, and guide the author on where and how the manuscript can be strengthened in order to better
      showcase the important contributions of the paper.
    </p>
    <p>On behalf of the authors and the editors of Journal Rhinology thank you for your time and comments.</p>
    <p>Do not include any statement that will indicate your judgment as to the acceptability of the paper.</p>
    <p>If possible, submit your comments in the following order: </p>
    <ol>
      <li>General comments</li>
      <li>Specific comments for revision: a) major; b) minor.</li>
    </ol>
  </div>
);

const reviewSaveButtons = (
  <div>
    <b>Done</b>
    <p>Commit Review</p>
    <p>
      Please keep in mind that If you don't have time to finish this form now you can press the save button below and
      continue your review at a later time
    </p>
  </div>
);

const commentToEditor = (
  <div>
    <b>Comments to the editor</b>
    <p>Comments from reviewer to Editor in Chief.</p>
  </div>
);

const classificationOfManuscript = (
  <table>
    <tbody>
      <tr>
        <td colSpan={2}>
          <b>This is the classification of your manuscript.</b>
        </td>
      </tr>
      <tr>
        <td style={{ width: "150px" }}>Review</td>
        <td>A review of an existing article.</td>
      </tr>
      <tr>
        <td style={{ width: "150px" }}>Original Contribution</td>
        <td>An origional contribution explaining your own research.</td>
      </tr>
      <tr>
        <td style={{ width: "150px" }}>Case Reports</td>
        <td>A report of a single case.</td>
      </tr>
      <tr>
        <td style={{ width: "150px" }}>Minireview</td>
        <td>A small review of an existing article.</td>
      </tr>
      <tr>
        <td style={{ width: "150px" }}>Special Reports</td>
        <td>A report of a special occurence.</td>
      </tr>
      <tr>
        <td style={{ width: "150px" }}>Historical Page</td>
        <td>An historical page.</td>
      </tr>
      <tr>
        <td style={{ width: "150px" }}>Society News</td>
        <td>News of the society.</td>
      </tr>
      <tr>
        <td style={{ width: "150px" }}>Surgical Contribution</td>
        <td>An contribution explaining a surgical method.</td>
      </tr>
      <tr>
        <td style={{ width: "150px" }}>Editorial</td>
        <td>An editorial written about an existing article.</td>
      </tr>
      <tr>
        <td style={{ width: "150px" }}>Systematic review</td>
        <td>Systematic review</td>
      </tr>
      <tr>
        <td style={{ width: "150px" }}>Letters to the Editor</td>
        <td>Letters to the Editor</td>
      </tr>
    </tbody>
  </table>
);

const summaryOfArticle = (
  <div>
    <p>This is a summary of your article.</p>
    <p> Your summary should contain: </p>
    <ul>
      <li>
        - <b>Introduction</b> to the subject
      </li>
      <li>
        - The <b>methods</b> of research used
      </li>
      <li>
        - The <b>results</b> of the research
      </li>
      <li>
        - The <b>conclusion</b>
      </li>
    </ul>
  </div>
);

const convertKeyToLabel = (label: string) => {
  switch (label) {
    case "significance":
      return "Significance of the research";
    case "originality":
      return "Orginality of research";
    case "design":
      return "Experimental design and quality of data";
    case "impact":
      return "Impact on clinical practice";
    case "relevance":
      return "Relevance/interest to rhinology";
    case "abstractQuality":
      return "Quality of abstract";
    case "conclusions":
      return "Conclusions";
    case "referencing":
      return "Adequate referencing";
    case "rating":
      return "If adequately revised the potential rating of the paper could be:";

    case "Acceptance":
      return "Acceptance (publishable as it is)";
    case "ConditionalAcceptance":
      return "Conditional acceptance (needs minor changes indicated in comments)";
    case "MinorRevision":
      return "Minor revision (needs minor/moderate revisions and further review)";
    case "MajorRevision":
      return "Major revision (needs substantial revisions and further review)";
    case "Rejection":
      return "Rejection (unlikely to be acceptable even after major revisions)";
    case "Rejection_Inappropriate":
      return "Rejection, inappropriate (not appropriate for this journal)";

    case "violation":
      return "Is there any question of violation of the journals policy on research involving animals and human beings?";
    case "editorialNeeded":
      return "Is an editorial needed?";
    case "volunteer":
      return "if an editorial is needed, are you willing to write one within 2 weeks?";
    default:
      return "Greska pri naslovu";
  }
};

export {
  coverLetter,
  articleTitle,
  type,
  firstTime,
  previousId,
  correction,
  keywords,
  abstract,
  manuscriptFigures,
  usersTitle,
  reviewComments,
  reviewSaveButtons,
  commentToEditor,
  titleOfManuscript,
  classificationOfManuscript,
  summaryOfArticle,
  convertKeyToLabel,
};
